export default __webpack_public_path__ + "static/media/Ms.229672e8.jpeg";